const classAnimation = 'animated'

export type AnimationIn = 'zoomIn' | 'slideInRight'
export  type AnimationOut = 'zoomOut' | 'slideOutRight'

export const setAnimations = (animations: Array<AnimationIn | AnimationOut>): string => {
  return `${classAnimation} ${animations.map(a => `${classAnimation}__${a}`).join(' ')}`
}